module.exports = __webpack_public_path__ + "static/media/att_27.eea09901.jpg";